/**
 * 관리자 비밀번호 정책 — BE PasswordPolicy(DEC-010)와 같다: 10자 이상 + 영문·숫자·특수문자 3종 모두.
 * 계정 생성·본인 변경·최고관리자 초기화가 모두 이 기준을 쓴다(QA-514 — 본인 변경 안내가 옛 8자 기준이라 저장이 거부됐다).
 */
export const ADMIN_PASSWORD_MIN_LENGTH = 10;

export const isValidAdminPassword = (raw: string): boolean => {
  if (raw.length < ADMIN_PASSWORD_MIN_LENGTH) return false;
  const kinds = [/[A-Za-z]/u.test(raw), /\d/u.test(raw), /[^A-Za-z\d]/u.test(raw)].filter(Boolean).length;
  return kinds >= 3;
};
